import { Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface ITitle {
  title: string;
  texts: string[];
}

export const Title = ({ title, texts }: ITitle) => {
  const isDesktop = useIsDesktop();
  return (
    <>
      <Typography
        variant='h2'
        color='text.secondary'
        margin={isDesktop ? '48px 0 16px 0' : '16px 0 8px 0'}
        component='h1'
      >
        {title}
      </Typography>
      <Stack gap={isDesktop ? '8px' : '4px'} direction='column'>
        {texts.map((text: string, index: number) => {
          return (
            <Typography key={index} variant='body3' color='text.secondary'>
              {text}
            </Typography>
          );
        })}
      </Stack>
    </>
  );
};
